import { createTheme } from '@mui/material/styles';
import defaultPallete from './defaultPallete';

const theme = createTheme({
  palette: defaultPallete,
});

export default theme;
